/*const colors = [
  "#cd0223", "#d45331", "#e39255", "#ecbb10", "#e3d98a", "#47e643", "#28cbb9", "#049496", "#2f7ecc", "#674ed8", "#a059ed", "#ba04ff", "#ba05a5"
];*/

const colors = [
  "#ff0000", "#ff8c00", "#ffff00", "#c0c0c0", "#ffffff", "#228b22", "#00ff7f", "#00ffff", "#0000ff", "#87cefa", "#8a2be2", "#ee82ee", "#ff0000"
];

export default colors;